import React from 'react';
import PlatformIcon from './PlatformIcon';

function PlatformButton({
  variant = 'primary',
  size = 'md',
  children,
  icon,
  className = '',
  ...rest
}) {
  return (
    <button
      type="button"
      className={`platform-btn platform-btn--${variant} platform-btn--${size} ${className}`.trim()}
      {...rest}
    >
      {icon && <PlatformIcon name={icon} size={size === 'lg' ? 18 : 15} />}
      {children}
    </button>
  );
}

export default PlatformButton;
